import {Theme, createStyles} from '@material-ui/core';
import {StyleRules} from '@material-ui/core/styles';

const editPublicHolidayStyles = (_theme: Theme): StyleRules =>
	createStyles({
		dialogBox: {
			height: 'fit-content',
			width: 'fit-content',
		},
	});

export default editPublicHolidayStyles;
